import React, { Dispatch, SetStateAction, useState } from 'react';
import { SunFilled, SunOutlined } from '@ant-design/icons';
import { Slider } from 'antd';

interface IconSliderProps {
    max: number;
    min: number;
    brightness: number;
    setBrightness: Dispatch<SetStateAction<number>>;
}

const SliderComp: React.FC<IconSliderProps> = (props) => {
    const { max, min, brightness, setBrightness } = props;

    const mid = Number(((max - min) / 2).toFixed(5));
    const preColorCls = brightness >= mid ? '' : 'icon-wrapper-active';
    const nextColorCls = brightness >= mid ? 'icon-wrapper-active' : '';

    return (
        <div className="icon-wrapper">
            <SunOutlined className={preColorCls} />
            <Slider {...props} onChange={setBrightness} value={brightness} />
            <SunFilled className={nextColorCls} />
        </div>
    );
};

export default SliderComp;